package com.milta.feature.imports.domain.usecase

import com.milta.feature.imports.domain.entity.ImportResult
import com.milta.feature.imports.domain.repository.ImportRepository

/** POST /api/v1/imports/{importSessionId}/retry (DOM-02, écrans C/D). */
class RetryImportUseCase(private val repository: ImportRepository) {
    suspend operator fun invoke(importSessionId: String, fileBytes: ByteArray, fileName: String): ImportResult =
        repository.retryImport(importSessionId, fileBytes, fileName)
}
